import request from "../config/axios-config";

export function getUserDetails() {
  return request({
    url: "/user/details",
    method: "get"
  });
}

export function getUsers() {
  return request({
    method: "get",
    url: "/user/all"
  });
}

export const uploadSignature = async (file, userId) => {
  let formData = new FormData();
  formData.append("file", file);

  return request({
    method: "post",
    url: "/user/upload/signature/" + userId,
    data: formData
  });
};
